import { SVGProps } from 'react'

export const SellButtonIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25rem"
      height="20rem"
      viewBox="0 0 25 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.33 5.02V10.86L19.24 13.78L14.15 10.86V5.02L19.24 2.1L24.33 5.02ZM23.33 5.6L19.24 3.25L15.15 5.6V10.28L19.24 12.63L23.33 10.28V5.6Z"
        fill="url(#paint0_linear_2136_5377)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.7 2.07L12.76 4.99L12.75 10.86L7.67 13.81L2.61 10.89L2.63 5.02L7.7 2.07ZM7.7 3.23L3.63 5.6L3.61 10.31L7.67 12.66L11.75 10.29L11.76 5.57L7.7 3.23Z"
        fill="url(#paint1_linear_2136_5377)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.55 10.33V16.17L13.46 19.09L8.37 16.17V10.33L13.46 7.41L18.55 10.33ZM17.55 10.9L13.46 8.56L9.37 10.9V15.59L13.46 17.94L17.55 15.59V10.9Z"
        fill="url(#paint2_linear_2136_5377)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2136_5377"
          x1="19.67"
          y1="5.5"
          x2="15.33"
          y2="14.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2136_5377"
          x1="5.79"
          y1="6.35"
          x2="11.27"
          y2="14.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2136_5377"
          x1="14.85"
          y1="11.5"
          x2="14.85"
          y2="20.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
